import { Component, computed, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import {
    FormRowComponent,
    InstructionsComponent,
    InstructionsWithFieldsContainerComponent,
} from '@r1-compass-library/components';
import { DataMartField } from '@r1-compass-library/models';
import { DataMartLifecyclesTableStore } from '../../../lifecycle-rules/store/data-mart-lifecycles.store';
import { DivisionBasicSettingsFormService } from '../division-basic-settings-form.service';

@Component({
    selector: 'r1-compass-app-lifecycle-rules',
    imports: [
        InstructionsWithFieldsContainerComponent,
        InstructionsComponent,
        FormRowComponent,
        MatFormFieldModule,
        MatSelectModule,
        ReactiveFormsModule,
    ],
    template: `
        <r1-compass-lib-instructions-with-fields-container>
            <r1-compass-lib-instructions headerText="Lifecycle Rules" instructions>
                Enter the fields in the Lifecycle Rules table that represent the Salesforce-generated Play and
                Recommendation IDs.
            </r1-compass-lib-instructions>
            <form formArea [formGroup]="formService.divisionBasicSettingsForm">
                <r1-compass-lib-form-row name="Salesforce Play ID">
                    <mat-form-field>
                        <mat-label>Salesforce Play ID</mat-label>
                        <mat-select formControlName="lifecycleRulePlayRecordIdField">
                            @for (field of lifecycleTable(); track $index) {
                                <mat-option [value]="field.name">{{ field.displayName }} ({{ field.name }})</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </r1-compass-lib-form-row>
                <r1-compass-lib-form-row name="Salesforce Recommendation ID">
                    <mat-form-field>
                        <mat-label>Salesforce Recommendation ID</mat-label>
                        <mat-select formControlName="lifecycleRuleRecommendationIdField">
                            @for (field of lifecycleTable(); track $index) {
                                <mat-option [value]="field.name">{{ field.displayName }} ({{ field.name }})</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </r1-compass-lib-form-row>
            </form>
        </r1-compass-lib-instructions-with-fields-container>
    `,
})
export class LifecycleRulesComponent implements OnInit {
    protected readonly formService = inject(DivisionBasicSettingsFormService);
    readonly #lifecyclesStore = inject(DataMartLifecyclesTableStore);

    protected lifecycleTable = computed<DataMartField[]>(
        () =>
            this.#lifecyclesStore
                .tables()
                ?.at(0)
                ?.fields.sort(function (a, b) {
                    return a.displayName.localeCompare(b.displayName);
                }) ?? []
    );

    ngOnInit(): void {
        this.#lifecyclesStore.getTables();
    }
}
